import { EnvironmentProviders } from '@angular/core';
import { Route, RouterFeatures, withPreloading, withRouterConfig, withViewTransitions } from '@angular/router';

import { isViewTransitionsEnabled } from '@frontend/vanilla/core';
import { SpeculativeLinkPreloader } from '@frontend/vanilla/features/speculative-link';
import { provideContextAwareRouter } from '@frontend/vanilla/ssr';

import { onViewTransitionCreated } from './view-transition/view-transition';

export function provideHostRouter(routes: Route[]): EnvironmentProviders {
    const features: RouterFeatures[] = [withPreloading(SpeculativeLinkPreloader), withRouterConfig({ urlUpdateStrategy: 'eager' })];

    if (isViewTransitionsEnabled()) {
        features.push(withViewTransitions({ skipInitialTransition: true, onViewTransitionCreated }));
    }

    return provideContextAwareRouter(routes, features);
}
